import React, {useState, useEffect} from 'react';
import PropTypes from "prop-types";
import SelectControl from "../common/SelectControl";
import TextBoxControl from "../common/TextBoxControl";
import {
    Aux, DATE_SHORT_FORMAT,
    orders_list_list_all_organisations_all,
} from "../../constants";
import {YesOrNo} from "../orders/AwningView";
import ColourSelectorControl from "../common/ColourSelectorControl";
import AwningAttachments from "../orders/AwningAttachments";
import TextAreaControl from "../common/TextAreaControl";
import DatePickerControl from "../common/DatePickerControl";
import {SupportRequestInitialState, SupportRequestTypes, SupportRequestValidationRules} from "./SupportRequestPage";
import moment from "moment/moment";
import DatePicker from "react-datepicker";


export const CreateSupportRequestView = (props) => {
    let {onSave, products, states, customColours, standardColours, organisations, user} = props;

    const [supportRequest, setSupportRequest] = useState({...SupportRequestInitialState});
    const [validationMessages, setValidation] = useState({});
    const [isValid, setIsValid] = useState(null);

    const onFieldUpdateByName = (name, value) => {
        let updateRequest = {...supportRequest};
        updateRequest[name] = value;
        setSupportRequest(updateRequest);
    };

    const onFieldUpdate = (e) => {
        let updateRequest = {...supportRequest};
        updateRequest[e.target.name] = e.target.value;
        setSupportRequest(updateRequest);
    };

    useEffect(() => {
        if (isValid === false) {
            runValidation();
        }
    }, [supportRequest, isValid]);

    useEffect(() => {
        let product = products.find(x => x.value === supportRequest.productId);
        let productDescription = product && product.value !== -1 ? product.label : '';
        setSupportRequest({...supportRequest, productDescription});
    }, [supportRequest.productId]);

    useEffect(() => {
        setSupportRequest({...supportRequest, organisationId: user.organisation.id});
    }, [user.organisation.id]);

    const runValidation = () => {
        let newValidationMessages = {};
        let isValid = true;
        for (let rule in SupportRequestValidationRules) {
            let result = SupportRequestValidationRules[rule].validator(supportRequest);
            if (!result.isValid) {
                newValidationMessages[rule] = result.message;
                isValid = false;
            }
        }
        setValidation({...newValidationMessages});
        setIsValid(isValid);
        return isValid;
    };

    const handleOnSave = () => {
        if (runValidation()) {
            onSave(supportRequest);
        }
    };
    
    const handleReset = () =>{
        setSupportRequest({...SupportRequestInitialState, organisationId: user.organisation.id});
        setIsValid(null);
        setValidation({});
    };

    return (<Aux>
        <div className={"row mt-5 mb-5"}>
            <div className={"col-6"}>
                <h2>Create Product Support Request</h2>
            </div>
            <div className={"col-6 text-right"}>
                <button
                    className="btn pi-btn-base pi-btn-icon-big"
                    onClick={handleOnSave}>
                    <i className="fa fa-save"></i>&nbsp;Save
                </button>
                <button
                    className="btn pi-btn pi-btn-icon-big ml-3"
                    onClick={handleReset}>
                    <i className="fa fa-reload"></i>&nbsp;Reset
                </button>
            </div>
        </div>
        <div className={'row'}>
            <div className='col-md-6'>
                {user.hasAccessTag(orders_list_list_all_organisations_all) && <SelectControl
                    onChange={(value) => onFieldUpdateByName('organisationId', value)}
                    name={'organisationId'}
                    value={supportRequest.organisationId}
                    options={organisations}
                    simpleValue={true}
                    labelText={"Organisation"}
                    valueKey={'id'}
                    labelKey={'description'}
                    validationMessages={validationMessages}
                />}

                <SelectControl
                    onChange={(value) => onFieldUpdateByName('supportRequestType', value)}
                    name={'supportRequestType'}
                    value={supportRequest.supportRequestType}
                    options={SupportRequestTypes}
                    simpleValue={true}
                    labelText={"Request Type"}
                    validationMessages={validationMessages}
                />

                <SelectControl
                    onChange={(value) => onFieldUpdateByName('productId', value)}
                    name={'productId'}
                    value={supportRequest.productId}
                    options={products}
                    simpleValue={true}
                    labelText={"Product"}
                    validationMessages={validationMessages}
                />

                {supportRequest.productId === -1 && <TextBoxControl
                    isDebounce={true}
                    debounceeTimeOut={300}
                    onChange={onFieldUpdate}
                    labelText="Other Product Description"
                    value={supportRequest.productDescription}
                    name="productDescription"
                    type="text"
                    validationMessages={validationMessages}
                />}

                <TextBoxControl
                    isDebounce={true}
                    debounceeTimeOut={300}
                    onChange={onFieldUpdate}
                    labelText="Customer Reference Number"
                    value={supportRequest.customerReferenceNumber}
                    name="customerReferenceNumber"
                    type="text"
                    validationMessages={validationMessages}
                />

                <SelectControl
                    onChange={(value) => onFieldUpdateByName('isRelationToExistingProductSupplied', value)}
                    name={'isRelationToExistingProductSupplied'}
                    value={supportRequest.isRelationToExistingProductSupplied}
                    options={YesOrNo}
                    simpleValue={true}
                    labelText={"Does this relate to an existing product supplied by Aluxor?"}
                    validationMessages={validationMessages}
                />

                {supportRequest.isRelationToExistingProductSupplied === false &&
                    <TextAreaControl
                        labelText={"Supplied By"}
                        name={"supplyNotes"}
                        onChange={onFieldUpdate}
                        value={supportRequest.supplyNotes}
                        validationMessages={validationMessages}
                    />
                }
                {supportRequest.isRelationToExistingProductSupplied === true &&
                    <Aux>
                        <TextBoxControl
                            isDebounce={true}
                            debounceeTimeOut={300}
                            onChange={onFieldUpdate}
                            labelText="Original Order Customer Reference"
                            value={supportRequest.originalOrderReference}
                            name="originalOrderReference"
                            type="text"
                            validationMessages={validationMessages}
                        />

                        <DatePickerControl
                            labelText={"Original Order Date"}
                            onChange={(val) => onFieldUpdateByName('originalOrderDate', val ? val.format() : null)}
                            selected={supportRequest.originalOrderDate ? moment(supportRequest.originalOrderDate) : null}
                            name={"originalOrderDate"}
                            validationMessages={validationMessages}
                        />

                    </Aux>
                }

                <ColourSelectorControl
                    onChange={(val) => {
                        setSupportRequest({
                            ...supportRequest,
                            colourId: val.selectedStandardColourId,
                            customColourId: val.selectedCustomColourId
                        });
                    }}
                    label=''
                    customColours={customColours}
                    standardColours={standardColours}
                    selectedStandardColourId={supportRequest.colourId}
                    selectedCustomColourId={supportRequest.customColourId}
                    name={'colour'}
                    validationMessages={validationMessages}
                    disabled={false}
                    awningId={0}
                    radioStyle={{paddingLeft: '15px'}}
                    singleColourSelection={false}
                    linkText={'Clear selection'}
                    onLink={(e) => {
                        e.preventDefault();
                        setSupportRequest({...supportRequest, colourId: null, customColourId: null});
                    }}
                />

                <TextAreaControl labelText={"Support Description"}
                                 name="supportDescription"
                                 onChange={onFieldUpdate}
                                 value={supportRequest.supportDescription}
                                 validationMessages={validationMessages}/>

                <AwningAttachments
                    attachments={supportRequest.attachments}
                    onChange={(attachments) => {
                        setSupportRequest({...supportRequest, attachments});
                    }}
                />

            </div>
            <div className='col-md-6'>
                <TextBoxControl
                    onChange={onFieldUpdate}
                    labelText="Location of Awning Address Line 1"
                    value={supportRequest.locationAddressLine1}
                    name="locationAddressLine1"
                    validationMessages={validationMessages}
                />

                <TextBoxControl
                    onChange={onFieldUpdate}
                    labelText="Location of Awning Address Line 2"
                    value={supportRequest.locationAddressLine2}
                    name="locationAddressLine2"
                    validationMessages={validationMessages}
                />

                <TextBoxControl
                    onChange={onFieldUpdate}
                    labelText="Location of Awning Postcode"
                    value={supportRequest.locationPostCode}
                    name="locationPostCode"
                    validationMessages={validationMessages}
                />

                <TextBoxControl
                    onChange={onFieldUpdate}
                    labelText="Location of Awning Suburb"
                    value={supportRequest.locationSuburb}
                    name="locationSuburb"
                    validationMessages={validationMessages}
                />

                <SelectControl
                    validationMessages={validationMessages}
                    labelText="Location of Awning State"
                    name="locationStateId"
                    options={states}
                    valueKey={'id'}
                    labelKey={'description'}
                    simpleValue={true}
                    onChange={(v) => onFieldUpdateByName('locationStateId', v)}
                    value={supportRequest.locationStateId}
                    placeholder="Delivery State"
                />
            </div>
        </div>
    </Aux>);
}

CreateSupportRequestView.propTypes = {        
    onSave: PropTypes.func.isRequired,    
    products: PropTypes.array.isRequired,
    states: PropTypes.array.isRequired,
    standardColours: PropTypes.array.isRequired,
    customColours: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    organisations: PropTypes.array.isRequired,
};